import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useSnackbar } from 'notistack';
import FulfilmentLocationForm from '../FulfilmentLocationForm';
import FormDrawer from '@afosto/app-components-react/FormDrawer';
import { addresses as addressesApi } from '@afosto/contacts/api/Addresses';
import { fulfilment as fulfilmentApi } from '@afosto/fulfilment/api/Fulfilment';
import translations from './translations';

const EditFulfilmentLocationDrawer = ({ location, open, onClose, onSuccess }) => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();
  const formRef = useRef(null);

  /**
   * Update the fulfilment location.
   */
  const handleUpdateLocation = async (formData = {}) => {
    try {
      const { name, address: newAddress } = formData;

      const response = await fulfilmentApi.updateFulfilmentLocation(location?.id, {
        name,
        address_id: newAddress?.id,
      });
      const { data: updatedLocation } = response;
      const addressResponse = await addressesApi.viewAddress(updatedLocation.address_id);
      const { data: addressData } = addressResponse;
      const extendedData = {
        ...updatedLocation,
        address: {
          addressData,
          value: addressData?.id,
          label: `${addressData?.address_line_1}, ${addressData?.postal_code} ${addressData?.locality} ${addressData?.country_code}`,
          description: `${addressData?.given_name}${
            addressData?.additional_name ? ` ${addressData?.additional_name}` : ''
          } ${addressData?.family_name}${
            addressData?.organisation ? `, ${addressData?.organisation}` : ''
          }`,
        },
      };

      await onSuccess(extendedData);

      enqueueSnackbar(intl.formatMessage(translations.feedback.fulfilmentLocationUpdated), {
        variant: 'success',
      });
    } catch (error) {
      const { message, code } = error?.response?.data ?? {};
      if (message && message.toLowerCase() === 'conflict' && code === 400) {
        formRef.current.setError(
          'address',
          'addressAlreadyLinkedToLocation',
          'This address has already been used',
        );
      } else {
        enqueueSnackbar(intl.formatMessage(translations.feedback.fulfilmentLocationNotUpdated), {
          variant: 'error',
        });
      }
    }
  };
  return (
    <FormDrawer
      isOpen={open}
      title={intl.formatMessage(translations.title)}
      drawerWidth="400px"
      onClose={onClose}
    >
      <FulfilmentLocationForm
        location={location}
        onSubmit={handleUpdateLocation}
        onCancel={onClose}
        formRef={formRef}
      />
    </FormDrawer>
  );
};

EditFulfilmentLocationDrawer.propTypes = {
  location: PropTypes.object,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
};

EditFulfilmentLocationDrawer.defaultProps = {
  location: undefined,
  open: false,
  onClose: undefined,
  onSuccess: undefined,
};

export default EditFulfilmentLocationDrawer;
